export const initialState = {
  useCredits: true,
  isQueueFetching: false,
  isInquireFetching: false,
  canBuyInOneClick: false,
  queueProducts: [],
  inquireData: {
    discount: 0,
    total: 0,
  },
}

export const setQueueFetchingStatus = (state, payload) =>
  ({ ...state, isQueueFetching: payload })

export const setQueueProducts = (state, payload) =>
  ({ ...state, isQueueFetching: false, queueProducts: payload })

export const setInquireFetchingStatus = (state, payload) =>
  ({ ...state, isInquireFetching: payload })

export const setInquireData = (state, payload) =>
  ({ ...state, isInquireFetching: false, inquireData: payload })

export const setCanBuyInOneClickStatus = (state, payload) =>
  ({ ...state, canBuyInOneClick: payload })

export const setUseCredits = (state, payload) =>
  ({ ...state, useCredits: payload })
